<template>
  <vue-popover :type="`p-2 popover-sm ${popoverType}`">
    <p class="w-full flex">
      <vue-button class="w-1/2 btn btn-sm btn-gray mr-1">Annuler</vue-button>
      <vue-button @click="$emit('confirmed')" class="w-1/2 btn btn-sm" :class="btnConfirmClass">
      {{ btnConfirmText }}
      </vue-button>
    </p>
    <vue-button slot="trigger"
                :icon="btnIcon"
                class="btn"
                :class="btnClass"
                :status="status"
                :disabled="disabled">
      <slot></slot>
    </vue-button>
  </vue-popover>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: null,
    },
    btnClass: {
      type: String,
      default: 'btn-primary',
    },
    btnIcon: {
      type: String,
      default: null,
    },
    btnConfirmText: {
      type: String,
      default: 'Confirmer',
    },
    btnConfirmClass: {
      type: String,
      default: 'btn-primary',
    },
    popoverType: {
      type: String,
      default: 'popover-top',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
